var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.show)?_c('div',{class:_vm.config.class,style:(_vm.config.style)},[_c('b',[_vm._v(_vm._s(_vm.config.label ? _vm.config.label + ': ' : ''))]),_vm._v(_vm._s(_vm.value)+"\r\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }